import { MutationTree } from 'vuex';
import { ISelectedPageFieldIds } from '../types/selected-page-field-ids';
import { IFieldState } from './field.types';
import { EFieldMutation } from './field.constants';
import { IField } from '@/dealroom/fields/types/field';

export const mutations: MutationTree<IFieldState> = {
  [EFieldMutation.SetLoading](state: IFieldState, loading: boolean) {
    state.loading = loading;
  },
  [EFieldMutation.SetDocumentId](state: IFieldState, documentId: string) {
    state.documentId = documentId;
  },
  [EFieldMutation.Set](state: IFieldState, fields: IField[]) {
    state.fields = fields;
  },
  [EFieldMutation.Add](state: IFieldState, fields: IField[]) {
    state.fields = [...state.fields, ...fields];
  },
  [EFieldMutation.Remove](state: IFieldState, fields: IField[]) {
    state.fields = state.fields.filter(
      (stateField: IField) => !fields.map((field: IField) => field.id).includes(stateField.id)
    );
  },
  [EFieldMutation.Update](state: IFieldState, field: IField) {
    state.fields = state.fields.map((stateField: IField) =>
      stateField.pageId === field.pageId && stateField.id === field.id ? field : stateField
    );
  },
  [EFieldMutation.ReplaceFieldWithTempId](
    state: IFieldState,
    { field, tempId }: { field: IField; tempId: string }
  ) {
    state.fields = state.fields.map((stateField: IField) =>
      stateField.pageId === field.pageId && stateField.id === tempId ? field : stateField
    );
  },
  [EFieldMutation.Select](state: IFieldState, field: IField) {
    if (!state.selectedPageFieldIds.pageId) {
      state.selectedPageFieldIds.pageId = field.pageId;
    }

    if (
      state.selectedPageFieldIds.pageId === field.pageId &&
      !state.selectedPageFieldIds.fieldIds.includes(field.id)
    ) {
      state.selectedPageFieldIds.fieldIds.push(field.id);
    }
  },
  [EFieldMutation.SetSelectedPageFieldIds](
    state: IFieldState,
    selectedPageFieldIds: ISelectedPageFieldIds
  ) {
    state.selectedPageFieldIds = selectedPageFieldIds;
  },
  [EFieldMutation.Deselect](state: IFieldState, field: IField) {
    state.selectedPageFieldIds.fieldIds = state.selectedPageFieldIds.fieldIds.filter(
      (id: string) => id !== field.id
    );
    if (state.selectedPageFieldIds.fieldIds.length === 0) {
      state.selectedPageFieldIds.pageId = null;
    }
  },
  [EFieldMutation.SetSelected](state: IFieldState, selectedFields: IField[]) {
    state.selectedPageFieldIds.fieldIds = selectedFields.map((field: IField) => field.id);
  },
  [EFieldMutation.DeselectAll](state: IFieldState) {
    state.selectedPageFieldIds.pageId = null;
    state.selectedPageFieldIds.fieldIds = [];
  },
  [EFieldMutation.SetPageWidth](state: IFieldState, pageWidth: number) {
    state.pageWidth = pageWidth;
  },
  [EFieldMutation.SetFocusedFieldId](state: IFieldState, fieldId: string) {
    state.focusedFieldId = fieldId;
  },
  [EFieldMutation.SetId](state: IFieldState, { field, id }: { field: IField; id: string }) {
    state.fields = state.fields.map((stateField: IField) =>
      JSON.stringify(stateField) === JSON.stringify(field) ? { ...stateField, id } : stateField
    );
  },
  [EFieldMutation.SetSenderSignature](state: IFieldState, senderSignature: string) {
    state.senderSignature = senderSignature;
  },
  [EFieldMutation.SetTabFieldId](state: IFieldState, tabFieldId: string) {
    state.tabFieldId = tabFieldId;
  },
  [EFieldMutation.SetLastUpdatedFieldId](state: IFieldState, fieldId: string) {
    state.lastUpdatedFieldId = fieldId;
  },
  [EFieldMutation.SetSelectBox](state: IFieldState, selectedPageFieldIds: ISelectedPageFieldIds) {
    state.markedPageFieldIds = { ...selectedPageFieldIds };
  },
};
